export default {"src":"/_next/static/media/curved-items-landing-2.d27bf6ac.svg","height":94,"width":94,"blurWidth":0,"blurHeight":0};